<mat-dialog-content>
  <p>{{ 'DEMAND_REQUEST.DETAIL.PRODUCT_DELETE_DIALOG.MESSAGE' | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>{{ 'SHARED.CANCEL' | translate }}</button>
  <button (click)="onConfirmClicked()" mat-flat-button color="primary">{{ 'SHARED.DELETE' | translate }}</button>
</mat-dialog-actions>
